import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { GiftCard } from '@models/gift-cards/gift-card';
import { GiftCardsService } from '@services/gift-cards.service';

@Component({
  selector: 'app-gift-card-lookup',
  templateUrl: './gift-card-lookup.component.html',
  styleUrls: ['./gift-card-lookup.component.less'],
})
export class GiftCardLookupComponent implements OnInit, AfterViewInit {
  @ViewChild('gcNumber') gcNumber: ElementRef<HTMLInputElement>;
  @Input() purchaseAmount?: number;

  private _disabled = false;
  @Input() set disabled(disabled: boolean) {
    this._disabled = disabled;
    if (disabled) this.gcCodeForm.disable({ emitEvent: false });
    else this.gcCodeForm.enable({ emitEvent: false });
    // Refresh gift card to update balance
    if (this.giftCard) this.findGiftCard();
  }
  get disabled() {
    return this._disabled;
  }

  @Output() giftCardSelected = new EventEmitter<GiftCard>();
  gcCodeForm = new FormControl('', Validators.required);
  giftCard: GiftCard;
  errorMessage: string;

  constructor(private giftCardService: GiftCardsService) {}

  ngOnInit(): void {
    this.gcCodeForm.valueChanges.subscribe((value) => {
      this.giftCard = null;
      this.giftCardSelected.emit(null);
      this.errorMessage = null;
      this.gcCodeForm.setValue(this.formatGcCode(value), { emitEvent: false });
    });
  }

  private formatGcCode(gcCode: string) {
    return gcCode?.replace(/(\S{3}(?!\s))(?!$)/g, '$1 ');
  }

  ngAfterViewInit(): void {
    this.gcNumber.nativeElement.focus();
  }

  isBalanceTooLow() {
    return this.giftCard && this.purchaseAmount && this.giftCard.balance < this.purchaseAmount;
  }

  findGiftCard() {
    let gcCode = this.gcCodeForm.value as string;
    gcCode = gcCode.replace(/\s/g, '');
    this.giftCardService.getGiftCardById(gcCode).subscribe(
      (giftCard) => {
        this.giftCard = giftCard;
        this.giftCardSelected.emit(giftCard);
        this.errorMessage = null;
      },
      (error) => {
        this.giftCard = null;
        this.giftCardSelected.emit(null);
        this.errorMessage = error.error?.title;
      }
    );
  }
}
